import { mapGetters } from 'vuex';

export const scroll = {
  computed: {
    ...mapGetters({
      isHeaderScrolled: 'general/isScrolled'
    })
  },
  methods: {
    scrollToError(offset = this.isHeaderScrolled ? -60 : -90, container = 'body') {
      const containerEl = container === 'body' ? document : document.querySelector(container);
      const errorEl =
        containerEl?.querySelector('.v-input.error--text:not(.v-messages)') ||
        containerEl?.querySelector('.error--text:not(.d-none)');

      if (errorEl) {
        this.$scrollTo(errorEl, 300, {
          offset,
          container,
          force: true,
          onDone: () => {
            const focusTarget =
              errorEl.querySelector('textarea') || errorEl.querySelector('input') || errorEl;
            focusTarget?.focus();
          }
        });
      }
    },
    dialogScrollTop() {
      const dialogContent = document.querySelector('.v-dialog--active .dialog-main-content');
      if (dialogContent) {
        dialogContent.scrollTop = 0;
      }
    }
  }
};
